import React, { useState, useEffect } from "react";
import ModalNotEnoughQuota from './modal-notenough-quota';
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import Box from "@material-ui/core/Box";
import { TextField } from "@material-ui/core";
import BackspaceOutlinedIcon from "@material-ui/icons/BackspaceOutlined";
import VisibilityOutlinedIcon from '@material-ui/icons/VisibilityOutlined';
import AddIcon from "@material-ui/icons/Add";
import RemoveIcon from "@material-ui/icons/Remove";
import Tooltip from "@material-ui/core/Tooltip";
import PropTypes from "prop-types";
import moment from "moment";
import 'moment/locale/pt-br'
import { concat, first, isEmpty, orderBy, uniqBy } from "lodash";
import Confirm from "../../Confirm";
import WeekSelector from "../../Shared/WeekSelector";
import DefaultDataTable from "../../Shared/DefaultDataTable";
import Selector from "../../Shared/Selector";
import TabNavigationCtrlFilterPanel from "../../TabNavigationCtrlFilterPanel";
import ModalData from "./modal-data";
import ModalQuotaOverloaded from "./modal-quota-overload";
import ModalQuotaAlreadyScheduled from "./modal-quota-already-scheduled";
import useStyles from "./styles";
import { getDataStorage, removeDataStorage, setDataStorage } from "../../../utils/filterManagementDataStore";
import {compareDays, getQuotaDates, generateFullWeek, getTodayDate} from "./utils"
import DialogMessage from '../../Dialog';
import { ModalAddQuota } from './modal-add-quota';

const getDataStorageBranch = () => getDataStorage('client_quotas_config_checkSingleBranch');
const getDataStoragePlant = () => getDataStorage('client_quotas_config_selectedPlant');
const getDataStorageWeek = () => getDataStorage('client_quotas_config_selectedWeek');
const getDataStorageTurn = () => getDataStorage('client_quotas_config_selectedTurn');
const getDataStorageTurnControl = () => getDataStorage('client_quotas_config_turnControl');

const ClientQuotasTabComponent = ({
   blocks,
   quotas,
   branches,
   plantQuotas,
   sendContent,
   subtractQuantity,
   addQuantity,
   setQuantity,
   filter,
   setFilter,
   plants,
   subRoutes,
   onDeleteItem,
   onAddItem,
   onUpdateItem,
   getClientByDocument,
   getTransporterByCNPJ,
   turnControl,
   setTurnControl,
   clearClientQuotas,
   addNewClientQuota,
   editQuotaQuantity,
   cloneQuotasFromLastWeek,
   cloneQuotasLastWeekParams,
   getOnlyDataQuotasByWeek,
   loadClientsByNickname,
   loadClientsByDocument,
   loadTransportersByNickname,
   loadTransportersByDocument,
}) => {
   const classes = useStyles();
   const [deletingItem, setDeletingItem] = useState(null);
   const [dataConflict, setDataConflict] = useState(null);
   const [editingItem, setEditingItem] = useState({});
   const [isOpenAddForm, setOpenAddForm] = useState(false);
   const [isOpenUpdateForm, setOpenUpdateForm] = useState(false);
   const [isOpenDeleteModal, setOpenDeleteModal] = useState(false);
   const [availableQuotas, setAvailableQuotas] = useState(0);
   const [autofocus, setAutofocus] = useState(null)
   const [isOpenModalConfirmation, setIsOpenModalConfirmation] = useState(false)
   const [quotasOverloadData, setquotasOverloadData] = useState(false)
   const [isOpenModalOverloadQuotas, setIsOpenModalOverloadQuotas] = useState(false)
   const [isOpenDialogMessage, setIsOpenDialogMessage] = useState(false)
   const [isOpenDialogMessageQuotasAvailable, setIsOpenDialogMessageQuotasAvailable] = useState(false);
   const [availableQuotasDays, setAvailableQuotasDays] = useState(null);
   const [substractButtonTooltipMsg, setSubstractButtonTooltipMsg] = useState('');
   const [showSubtractButtonTooltip, setShowSubtractButtonTooltip] = useState(false);
   const [isOpenModalAlreadyScheduled, setIsOpenModalAlreadyScheduled] = useState(false);
   const [quotasAlreadyScheduled, setQuotasAlreadyScheduled] = useState(null);

   const ConfigButton = (item) => (
      <IconButton onClick={() => handleEditItem(item)}>
         <VisibilityOutlinedIcon/>
      </IconButton>
   );

   const handleEditItem = (item) => {
      setEditingItem({ ...item });
      setOpenUpdateForm(true);
   };

   const handleAddQuota = () => {

      let sumPlantQuotas = 0;
      if(availableQuotasDays) {
         Object.values(availableQuotasDays).map(av => {
            av.map(a => {
               if(a.available > 0 ) {
                  sumPlantQuotas += a.available;
               }
               return false;
            });
            return false;
         })
      }

      if (sumPlantQuotas > 0){
         setOpenAddForm(true);
      } else {
         setIsOpenDialogMessageQuotasAvailable(true);
      }

   };

   useEffect(() => {
      async function checkAvailableQuotas() {

         const plant_date = getDataStorage('client_quotas_config_selectedWeek')?.ref || filter.clientQuotasDate;
         const plant_id = getDataStorage('client_quotas_config_selectedPlant')?.id || filter.clientQuotasPlant;
         const turn_id = getDataStorage('client_quotas_config_selectedTurn')?.id || filter.clientQuotasTurn;

         const start_week_date = moment(plant_date).clone().weekday(0).format('YYYY-MM-DD');
         const end_week_date = moment(plant_date).clone().weekday(6).format('YYYY-MM-DD');

         if(plant_id) {
            const response = await getOnlyDataQuotasByWeek(
               plant_id,
               start_week_date,
               end_week_date,
               turn_id
            );
            setAvailableQuotasDays(response.data);
         }


      }

      checkAvailableQuotas();

    }, [filter, getOnlyDataQuotasByWeek]);


   const handleImportLastWeekData = async (confirm) => {
      const alreadyHasQuotasThisWeek = checkIfHasQuotasThisWeek();
      const hasQuotasLastWeek = await checkIfHasQuotasLastWeek();

      if(!hasQuotasLastWeek) {
        setIsOpenDialogMessage(true)
        return;
      }

      if(alreadyHasQuotasThisWeek) {
        setIsOpenModalConfirmation(true)
      }

      if(!alreadyHasQuotasThisWeek || confirm === true ) {
        prepareImportLastWeekData()
      }

      if( typeof(confirm) !== 'undefined' ) {
        setIsOpenModalConfirmation(false)
      }
    }

    const checkIfHasQuotasLastWeek = async () => {
      const paramsData = getImportLastWeekparams()

      const hasQuotas = await getOnlyDataQuotasByWeek(
        paramsData.plantId,
        paramsData.plantStartDateLastWeek,
        paramsData.plantEndDateLastWeek,
        paramsData.timeBlockId
      );

      return hasQuotas?.data?.quotas.length ? true : false
    }

   const getImportLastWeekparams = () => {
    const {plantStartDate, plantEndDate} = cloneQuotasLastWeekParams;
    const plantStartDateLastWeek = moment(plantStartDate).clone().weekday(-7).format('YYYY-MM-DD');
    const plantEndDateLastWeek = moment(plantEndDate).clone().weekday(-1).format('YYYY-MM-DD');

    return {
      ...cloneQuotasLastWeekParams,
      plantStartDateLastWeek,
      plantEndDateLastWeek
    }
   }

   const prepareImportLastWeekData = () => {
    const paramsData = getImportLastWeekparams()

    cloneQuotasFromLastWeek(
      paramsData.plantId,
      paramsData.plantStartDate,
      paramsData.plantEndDate,
      paramsData.plantStartDateLastWeek,
      paramsData.plantEndDateLastWeek,
      paramsData.timeBlockId
    )
   }

   const checkIfHasQuotasThisWeek = () => {
    return quotas.length > 0
   }

   const handleSaveData = (data) => {

    let newQuota = {
      client_id: null,
      fe_id: Math.floor(Math.random() * 100000),
      client_name: data.client_name,
      client_nickname: data.client_nickname ?? '',
      client_document: data.client_document,
      contract_number: data.contract_number,
      transporter_name: data.transporter_name,
      transporter_nickname: data.transporter_nickname ?? '',
      transporter_document: data.transporter_document,
      id_plant: filter.clientQuotasPlant || getDataStoragePlant()?.value,
      id_time_block: filter.clientQuotasTurn || getDataStorageTurn()?.value,
      dates: generateFullWeek(getDataStorageWeek()?.ref || filter.clientQuotasDate)
    };

    if(isClientTransporterAlreadyAdded(data?.client_document, data?.transporter_document)){
      return null;
    }

    return addNewClientQuota(newQuota);
   };

   const isClientTransporterAlreadyAdded = (client_document, transporter_document) => {
      const result = quotas.find(quota => {
         return quota.client_document === client_document && quota.transporter_document === transporter_document
      });

      return !!result;
   }

   const handleUpdateData = (data) => {
    return onUpdateItem(data)
   }

   const calculateAvailableQuotas = () => {
      const sumPlantQuotas =
         plantQuotas &&
         plantQuotas.reduce((total, currentValue) => total + currentValue.quantity, 0);
      const usedQuotas = quotas && quotas.reduce((total, currentValue) => total + parseInt(currentValue.quantity), 0);

      setAvailableQuotas(sumPlantQuotas - usedQuotas);
   };

   useEffect(calculateAvailableQuotas, [
      quotas,
      plantQuotas,
      filter.clientQuotasDate,
      setAvailableQuotas,
   ]);


   useEffect(() => {
    if (plants.filter(item =>  item.id === (filter.clientQuotasPlant || getDataStoragePlant()?.value) && item.id_reservation_type === 2).length > 0) {
      setTurnControl(true);
      setDataStorage('client_quotas_config_turnControl', true);
    } else {
      setTurnControl(false);
      setDataStorage('client_quotas_config_turnControl', false);
    }
   }
   ,[
     filter.clientQuotasBranch,
     filter.clientQuotasPlant,
     filter.clientQuotasDate,
     plants,
     setTurnControl
    ])

   const handleModalDeleteClose = (confirm) => {
     setOpenDeleteModal(false);
      if (confirm) {
         clearClientQuotas(deletingItem);
      }
      setDeletingItem(null);
   };

   const handleCloseDataModal = () => {
      setDeletingItem(null);
      setEditingItem({});
      setOpenAddForm(false);
   };

   const handleCloseUpdateDataModal = () => {
    setDeletingItem(null);
    setEditingItem({});
    setOpenUpdateForm(false);
 };

   const DeleteButton = (item) => (
      <IconButton
         data-cy="client-quota-remove"
         id="client-quota-remove"
         onClick={() => {
            setOpenDeleteModal(true);
            setDeletingItem(getQuotaDates(item));
         }}
      >
         <BackspaceOutlinedIcon />
      </IconButton>
   );

   const loadQuotas = () => {

     if (!filter.clientQuotaPlant && !getDataStoragePlant()){
        return [];
     } else {
      return quotas.filter(quota => quota.fe_id)
    }
   };

   const handleTurnIsValid = (selectedClientQuotasDate) => {

      const start_week_date = moment(selectedClientQuotasDate.ref).clone().weekday(0).format('YYYY-MM-DD');
      const end_week_date = moment(selectedClientQuotasDate.ref).clone().weekday(6).format('YYYY-MM-DD');

     if (!turnControl || !filter.clientQuotasTurn) return;
     const turn = blocks.find(e => e.id === filter.clientQuotasTurn);



     if (!turn || !turnIsValid(turn.start_date,turn.end_date,start_week_date, end_week_date)) {
      removeDataStorage('client_quotas_config_selectedTurn');
      filter.clientQuotasTurn = null;
     }

   }

   const turnIsValid = (turnStartDate, turnEndDate, startDate, endDate) => {
    return (
      (new Date(endDate) >= new Date(turnStartDate)) &&
      (
        (new Date(startDate) <= new Date(turnEndDate)) || (turnEndDate===null)
      )
    );
   }

   const handleBranchFilterChange = (selectedBranch) => {
     removeDataStorage('client_quotas_config_selectedPlant');
     filter.clientQuotasPlant = null;
     filter.clientQuotasTurn = null;
     setFilter({
       ...filter,
       clientQuotasBranch: selectedBranch && selectedBranch.value,
       clientQuotasPlant: null,
       clientQuotasTurn: null,
     });
   };

   const handleClientQuotasPlantFilterChange = (selectedClientQuotasPlant) => {
    removeDataStorage('client_quotas_config_selectedTurn');
     filter.clientQuotasTurn = null;
    setFilter({
       ...filter,
       clientQuotasPlant: selectedClientQuotasPlant && selectedClientQuotasPlant.value,
       clientQuotasTurn: null,
     });
   };

   const handleClientQuotasTurnFilterChange = (selectedClientQuotasTurn) => {
    setFilter({
      ...filter,
      clientQuotasTurn: selectedClientQuotasTurn && selectedClientQuotasTurn.value,
    });
   };

   const handleClientQuotasWeekFilterChange = (selectedClientQuotasDate) => {
    handleTurnIsValid(selectedClientQuotasDate);
    setFilter({
      ...filter,
      clientQuotasDate: selectedClientQuotasDate.ref,
      clientQuotasEndDate: selectedClientQuotasDate.endDate,
      clientQuotasStartDate: selectedClientQuotasDate.startDate
    });
   };

  const AddButton = (item) => {
    const { row, weekDay, currentCapacity } = item

    const indexDate = row.dates.findIndex(content => content.date === weekDay)
    const availableCapacity = row.dates[indexDate].available
    const areDocksLimitReached = currentCapacity  >= availableCapacity

    return (
      <Tooltip
        arrow
        placement="bottom-start"
        title="Não existem mais cotas para distribuir."
        disableHoverListener={!areDocksLimitReached}
      >
        <IconButton
          onClick={() => {
            if (!compareDays(weekDay, new Date())){
              !areDocksLimitReached && addQuantity(item);
            }
          }}
        >
          <AddIcon fontSize="small" color="primary"/>
        </IconButton>
      </Tooltip>
    );
  };

  const SubtractButton = (item) => {
    const { weekDay, currentCapacity, row } = item

    return (
      <Tooltip
        arrow
        placement="bottom-start"
        title={substractButtonTooltipMsg}
        disableHoverListener={!showSubtractButtonTooltip}
      >
        <IconButton
          onClick={() => {
            if(!compareDays(weekDay, new Date())){
              const quota = row.dates.find( (date) => date.date === weekDay );

              if(quota.alreadyScheduled >= quota.allocated) {
                return;
              }

              subtractQuantity(item);
            }
          }}

          onMouseEnter={() => {
            if(weekDay < getTodayDate()) {
              setShowSubtractButtonTooltip(false)
              return;
            }

            handleSubtractButton(weekDay, row, currentCapacity)
          }}
        >
          <RemoveIcon fontSize="small" color="primary" />
        </IconButton>
      </Tooltip>
    );
  };

  const handleSubtractButton = (weekDay, row, currentCapacity) => {
    if(!compareDays(weekDay, new Date())) {
      const quota = row.dates.find( (date) => date.date === weekDay );

      if(quota.alreadyScheduled > 0 ) {
        setSubstractButtonTooltipMsg(`Já existe(m) ${quota.alreadyScheduled} agendamento(s) para esse dia`)
        setShowSubtractButtonTooltip(true)
        return;
      }

      if(currentCapacity <= 0) {
        setSubstractButtonTooltipMsg(`Não podem ser declarados valores negativos`)
        setShowSubtractButtonTooltip(true)
        return;
      }

      setShowSubtractButtonTooltip(false)
    }
  }

  const handleWithWeekCells = ({ row, weekDay, currentCapacity }) => {
      const indexDate = row.dates.findIndex(content => content.date === weekDay);
      const allocatedQuantity = row.dates[indexDate].allocated ?? 0;
      const elementId = String(row.fe_id).concat("-").concat(weekDay);
      return (
        <>
          <SubtractButton {...{ row, weekDay, currentCapacity }} />
          <TextField
            id={elementId}
            variant="outlined"
            autoFocus={autofocus === elementId}
            disabled={compareDays(weekDay, new Date())}
            className={classes.quantity}
            value={allocatedQuantity}
            type="number"
            inputProps={{ min: '0', max: row.dates[indexDate].available }}
            onChange={(e) => {
              const targetValue = e.target.value;
              if (!isNaN(targetValue)) {
                setAutofocus(elementId);
                let newQuantity = targetValue;
                const { available:dockLimit, alreadyScheduled } = row.dates[indexDate];
                const isLimitReached = newQuantity > dockLimit;

                if (!isLimitReached) {
                  editQuotaQuantity({
                    row,
                    weekDay,
                    currentCapacity,
                    value: newQuantity>alreadyScheduled?newQuantity:alreadyScheduled
                  })
                } else {
                  editQuotaQuantity({
                    row,
                    weekDay,
                    currentCapacity,
                    value: alreadyScheduled??0
                  })
                }
              } else {
                if (!allocatedQuantity) {
                  editQuotaQuantity({row, weekDay, currentCapacity, value: 0})
                }
              }
            }
            }
          />
          <AddButton {...{ row, weekDay, currentCapacity  }} />
        </>
      );
    }

  const handleWithLabelWeeks = (dateLabel) => {
    const currentDateValue = moment(dateLabel).format('dddd')
    return currentDateValue.charAt(0).toUpperCase() + currentDateValue.substr(1)
  }

  const columnQuotas = orderBy(quotas?.map(item => {
    return item?.dates?.map(dateItem => {
      const weekDay = dateItem.date;
      const indexByWeekDay = item.dates.findIndex(item => item.date === weekDay)

      const currentCapacity = quotas.map((num) => {
        return num.dates[indexByWeekDay].allocated
      })
     .reduce((accumulator, value) => accumulator+value)

     const handleWithCurrentCapacity = parseInt(currentCapacity > dateItem.available ? dateItem.available : currentCapacity) || 0

      return {
        name: `${handleWithLabelWeeks(weekDay)}
          ${moment(weekDay).format('DD/MM/YYYY')}
           Distribuídas: ${handleWithCurrentCapacity}/${dateItem.available}`,
        day: handleWithLabelWeeks(weekDay),
        maxWidth: "170px",
        cell: (row) => handleWithWeekCells({ row,  weekDay, currentCapacity })
      }
    })
  } , 'date', 'asc'))

   const columns = [
      {
         name: "Nome do Cliente",
         selector: "client_name",
         maxWidth: "175px",
         sortable: true,
      },
      {
         name: "Transportadora",
         selector: "transporter_name",
         format: (row) => `${row.transporter_name ?? "Não informado."} ${row.transporter_document.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5") ?? "CNPJ não informado."}`,
         maxWidth: "225px",
         sortable: true,
         wrap: true
      },
   ];

   const columnActions = [
    {
      name: "Visualizar",
      maxWidth: "30px",
      cell: (row) => <ConfigButton {...row} />,
    },
    {
        name: "Limpar",
        maxWidth: "30px",
        cell: (row) => <DeleteButton {...row} />,
    },
  ]


  const days = ['Domingo', 'Segunda-feira', 'Terça-feira', 'Quarta-feira', 'Quinta-feira', 'Sexta-feira', 'Sábado']
  const columnQuotasResult = []

  days.forEach(key => {
    return columnQuotas.filter(item => {
       return item.filter(c => {
        if(c.day.toLowerCase() === key.toLowerCase()) {
          columnQuotasResult.push(c)
        }

        return c;
      })
    })
  })

  const handleColumnQuota = uniqBy(columnQuotasResult, 'day')

   const handleColumns = () => {
    if(first(columnQuotas)?.length > 0 ) {
      return concat(columns, handleColumnQuota, columnActions)
    }

    return concat(columns, columnActions)
  }

   const noDataMessage = () => {
      if (!filter.clientQuotasBranch && !getDataStorageBranch()) {
         return "Por favor, selecione uma filial.";
      }
      if (!filter.clientQuotasPlant && !getDataStoragePlant()) {
         return "Por favor, selecione uma planta.";
      }
      if (!filter.clientQuotasTurn && !getDataStorageTurn() && turnControl) {
        return "Por favor, selecione um turno.";
      }
      return "Não existem dados a serem apresentados.";
   };

  const handleOnChange = (funcChange, valueStorage, nameStorage) => {
    funcChange(valueStorage)
    if (valueStorage !== null) {
      setDataStorage(nameStorage, valueStorage);
    } else {
      removeDataStorage(nameStorage);
    }
  }

  const handleDisableBtn = () => {

   if(
      (!filter.clientQuotasBranch && !getDataStorageBranch()) ||
      (!filter.clientQuotasPlant && !getDataStoragePlant()) ||
      (!filter.clientQuotasTurn && turnControl && !getDataStorageTurn()) ||
      isEmpty(quotas)) {

         return true;
   }

   return false;
  }

  const todayDate = () => {
    return new Date().toLocaleDateString('en-CA')
  }

  const quotesGroupBy = (quotesData, propriety) => {
    return quotesData.reduce((acc, obj) => {
      let key = obj[propriety];
      if (!acc[key]) {
        acc[key] = [];
      }
      acc[key].push(obj);
      return acc;
    }, {});
  }

  const extractOnlyWeekDataOfQuotas = ( dataQuotas ) => {
    let weekDataQuotas = [];
    dataQuotas.forEach(({dates}) => {
      dates.forEach((date) => {
        weekDataQuotas.push(date);
      })
    })

    return weekDataQuotas;
  }

  const handleQuotasOverloadByDays = (dataQuotas) => {
    const onlyWeekQuotasData = extractOnlyWeekDataOfQuotas(dataQuotas)
    const quotasReservationGropyedByDaysOnWeek = quotesGroupBy(onlyWeekQuotasData, 'date')

    Object.values(quotasReservationGropyedByDaysOnWeek).map((quotaByDate) => {
      return quotaByDate.totalAllocated = quotaByDate.reduce((total, quota) => {
        quotaByDate.date = quota.date;
        quotaByDate.available = quota.available;
        const totalAllocated = total + quota.allocated
        quotaByDate.overloaded = totalAllocated > quota.available;
        return totalAllocated;
      }, 0)
    });

    return quotasReservationGropyedByDaysOnWeek;
  }

  const checkOverloadQuotasByDayOfWeek = (dataQuotas) => {
    const overloadedByDays = handleQuotasOverloadByDays(dataQuotas)
    const hasOverloadedByDay = [];

    Object.values(overloadedByDays).forEach(( (quotas, index) => {
      if( quotas.overloaded === false ) {
        return false;
      }

      hasOverloadedByDay.push({
        'date': quotas.date,
        'allocated': quotas.totalAllocated,
        'available': quotas.available
      })
    }));

    return hasOverloadedByDay;
  }

  const checkOverloadQuotas = (dataQuotas) => {
    const overloadQuotas = [];
    const hasOverloadedByDay = checkOverloadQuotasByDayOfWeek(dataQuotas);

    hasOverloadedByDay.forEach(quotaOverloaded => {
      if(quotaOverloaded.date >= todayDate()) {
        return overloadQuotas.push(quotaOverloaded);
      }
    })

    return overloadQuotas.length? overloadQuotas : false;
  }

  const validateQuotaData = (dataQuotas) => {
    const hasOverloadQuotas = checkOverloadQuotas(dataQuotas);

    if(hasOverloadQuotas) {
      setquotasOverloadData(hasOverloadQuotas);
      setIsOpenModalOverloadQuotas(true);
      return false;
    }

    return !hasOverloadQuotas;
  }

  const hdlSendContent = async (dataQuotas) => {
    const isValidData = validateQuotaData(dataQuotas);

    if( !isValidData ) {
      return;
    }

    const {success, data } = await sendContent(dataQuotas);

    if(!success) {
      if(data?.errorType === "error_quotas_scheduling_conflicts") {
        delete data.errorType;

        setQuotasAlreadyScheduled(data)
        setIsOpenModalAlreadyScheduled(true)
        return;
      }
      setDataConflict(data);
    } else {
      setDataConflict(null);
    }
  }

    return (
      <>
         <TabNavigationCtrlFilterPanel
            data-cy="client-quota-search"
            id="client-quota-search"
            headerFilter={
               <Grid className={classes.filters}>
                  <Grid className={classes.branchFilter}>
                     <Selector
                        options={branches}
                        placeholder="Filtrar por filial"
                        data-cy="client-quota-filter-branch"
                        id="client-quota-filter-branch"
                        search
                        isClearable
                        selected={filter.clientQuotasBranch ?? getDataStorageBranch()?.value}
                        value={getDataStorageBranch()}
                        onChange={(selectedBranch) =>
                          handleOnChange(
                            handleBranchFilterChange,
                            selectedBranch,
                            'client_quotas_config_checkSingleBranch'
                          )
                        }
                     />
                  </Grid>
                  <Grid className={classes.clientQuotasPlantFilter}>
                     <Selector
                        options={plants}
                        placeholder="Filtrar por Planta"
                        data-cy="client-quota-filter-plant"
                        id="client-quota-filter-plant"
                        selected={filter.clientQuotasPlant ?? getDataStoragePlant()?.value}
                        disabled={!filter.clientQuotasBranch && !getDataStorageBranch()}
                        value={getDataStoragePlant()}
                        isClearable
                        onChange={(selectedClientQuotasPlant) =>
                          handleOnChange(
                            handleClientQuotasPlantFilterChange,
                            selectedClientQuotasPlant,
                            'client_quotas_config_selectedPlant'
                          )
                        }
                     />
                  </Grid>
                  {turnControl || getDataStorageTurnControl()
                  ? <Grid className={classes.clientQuotasTurnFilter}>
                      <Selector
                        data-cy="client-quota-turn-filter"
                        id="client-quota-turn-filter"
                        options={blocks.map((item) => {
                          return {
                            label: item?.description,
                            name: item?.description,
                            value: item?.id}
                        })}
                        placeholder="Selecione um turno"
                        selected={filter.clientQuotasTurn ?? getDataStorageTurn()?.value}
                        disabled={!filter.clientQuotaPlant && !getDataStoragePlant()}
                        value={getDataStorageTurn()}
                        isClearable
                        onChange={(selectedClientQuotasTurn) =>
                          handleOnChange(
                            handleClientQuotasTurnFilterChange,
                            selectedClientQuotasTurn,
                            'client_quotas_config_selectedTurn'
                          )
                        }
                      />
                    </Grid>
                  : null
                  }
                  <Grid className={classes.clientQuotasWeekFilter}>
                    <WeekSelector
                      disabled={false}
                      nameStorage={'client_quotas_config_selectedWeek'}
                      data-cy="client-quota-week-selected"
                      id="client-quota-week-selected"
                      onChange={handleOnChange}
                      value={moment(getDataStorageWeek()?.ref).format("YYYY-MM-DD")}
                      selected={getDataStorageWeek()?.ref ?? moment(new Date()).valueOf()}
                      setFilter={handleClientQuotasWeekFilterChange}
                    />
                  </Grid>
               </Grid>
            }
            controlAreaClassName={classes.controlAreaClass}
            controlArea={
              <Box
                component="div"
                display="flex"
                style={{ width: '100%', padding: 0, margin: 0 }}
                justifyContent="flex-end"
                alignItems="center"
              >
                <Button
                  variant="contained"
                  size="large"
                  className={classes.importLastWeekData }
                  onClick={() => handleImportLastWeekData()}
                  data-cy="client-quota-import"
                  id="client-quota-import"
                  disabled={
                    (!filter.clientQuotasBranch && !getDataStorageBranch()) ||
                    (!filter.clientQuotasPlant && !getDataStoragePlant()) ||
                    (turnControl && !filter.clientQuotasTurn && !getDataStorageTurn()) ||
                    (!filter.clientQuotasDate && !getDataStorageWeek()) ||
                    (availableQuotas < 0) ||
                    compareDays(filter.clientQuotasDate, new Date())
                  }
                >
                  Importar da semana anterior
                </Button>

                <Button
                  color="primary"
                  variant="contained"
                  size="large"
                  style={{ maxWidth: '200px', height: '67px' }}
                  data-cy="client-add-quota"
                  id="client-add-quota"
                  disabled={
                    (!filter.clientQuotasBranch && !getDataStorageBranch()) ||
                    (!filter.clientQuotasPlant && !getDataStoragePlant()) ||
                    (turnControl && !filter.clientQuotasTurn && !getDataStorageTurn()) ||
                    (!filter.clientQuotasDate && !getDataStorageWeek()) ||
                    (availableQuotas < 0) ||
                    compareDays(filter.clientQuotasDate, new Date())
                  }
                  className={classes.addButton}
                  onClick={() => handleAddQuota()}
                >
                  Adicionar cotas cliente / fornecedor
                </Button>
                <Button
                  color="secondary"
                  variant="contained"
                  data-cy="client-quota-save"
                  id="client-quota-save"
                  size="large"
                  style={{ maxWidth: '200px', height: '67px', marginLeft: '10px'}}
                  disabled={handleDisableBtn()}
                  className={classes.saveButton}
                  onClick={() => hdlSendContent(quotas)}
                >
                  Salvar
                </Button>
               </Box>
            }
            subRoutes={subRoutes}
         >
            <DefaultDataTable
               columns={handleColumns()}
               data-cy="client-quota-table"
               id="client-quota-table"
               data={loadQuotas()}
               noDataMessage={noDataMessage()}
            />
         </TabNavigationCtrlFilterPanel>
         <Confirm
            isOpen={isOpenDeleteModal}
            title="Confirmar limpeza?"
            message="Deseja limpar as cotas alocadas para este cliente?"
            okText="Sim"
            data-cy="client-quota-confirm-clean"
            id="client-quota-confirm-clean"
            cancelText="Não"
            handleClose={handleModalDeleteClose}
         />
         <Confirm
            isOpen={isOpenModalConfirmation}
            title="Deseja importar os dados da semana anterior?"
            message="Isto irá causar a perda dos dados da semana selecionada."
            data-cy="client-quota-import-modal"
            id="client-quota-import-modal"
            okText="Sim"
            cancelText="Não"
            handleClose={handleImportLastWeekData}
         />
         <ModalAddQuota
            editedData={editingItem}
            isModalOpen={isOpenAddForm}
            handleModalClose={handleCloseDataModal}
            handleSave={handleSaveData}
            loadClientsByNickname={loadClientsByNickname}
            loadClientsByDocument={loadClientsByDocument}
            loadTransportersByNickname={loadTransportersByNickname}
            loadTransportersByDocument={loadTransportersByDocument}
         />
         <ModalData
            open={isOpenUpdateForm}
            editedData={editingItem}
            handleSave={handleUpdateData}
            getClientByDocument={getClientByDocument}
            getTransporterByCNPJ={getTransporterByCNPJ}
            handleClose={handleCloseUpdateDataModal}
            modalCaption={`Visualizar cliente/fornecedor`}
            readOnly={true}
            data-cy="client-quota-view-client"
            id="client-quota-view-client"
            actionButtonText={`Fechar`}
            receiveFeedback={false}
         />
         <ModalNotEnoughQuota
          data={dataConflict}
          isOpen={!!dataConflict && dataConflict.length}
          data-cy="client-quota-not-enough"
          id="client-quota-not-enough"
          closeReadingNotificationDialog={() => setDataConflict(null)}
        />
        <ModalQuotaOverloaded
          isOpen={isOpenModalOverloadQuotas}
          closeReadingNotificationDialog={() => {setIsOpenModalOverloadQuotas(false)}}
          data-cy="client-quota-overloaded"
          id="client-quota-overloaded"
          message="Não foi possível salvar, pois existem cotas reservadas além da capacidade."
          submessage="Favor revisar os dias a seguir e tentar novamente:"
          tableData={quotasOverloadData}
        />

        <ModalQuotaAlreadyScheduled
          isOpen={isOpenModalAlreadyScheduled}
          closeReadingNotificationDialog={() => {setIsOpenModalAlreadyScheduled(false)}}
          data-cy="client-quota-already-scheduled"
          id="client-quota-already-scheduled"
          message="Não foi possível salvar, pois existem agendamentos para as datas definidas"
          submessage="Favor revisar os dias a seguir e tentar novamente:"
          tableData={quotasAlreadyScheduled}
        />

        <DialogMessage
          isOpen={isOpenDialogMessage}
          subject="Atenção!"
          data-cy="client-quota-warning"
          id="client-quota-warning"
          message="Não há cotas na semana anterior, portanto, nenhuma ação foi realizada!"
          closeReadingNotificationDialog={() => setIsOpenDialogMessage(false)}
        />
        <DialogMessage
          isOpen={isOpenDialogMessageQuotasAvailable}
          data-cy="client-quota-warning-2"
          id="client-quota-warning-2"
          subject="Atenção!"
          message="Não há cotas alocadas para esse período."
          closeReadingNotificationDialog={() => setIsOpenDialogMessageQuotasAvailable(false)}
        />
      </>
   );
};

ClientQuotasTabComponent.propTypes = {
   blocks: PropTypes.array.isRequired,
   quotas: PropTypes.array.isRequired,
   plantQuotas: PropTypes.array.isRequired,
   branches: PropTypes.array.isRequired,
   filter: PropTypes.object.isRequired,
   setQuantity: PropTypes.func.isRequired,
   subtractQuantity: PropTypes.func.isRequired,
   addQuantity: PropTypes.func.isRequired,
   sendContent: PropTypes.func.isRequired,
   setFilter: PropTypes.func.isRequired,
   subRoutes: PropTypes.array.isRequired,
   onAddItem: PropTypes.func.isRequired,
   onUpdateItem: PropTypes.func.isRequired,
   onDeleteItem: PropTypes.func.isRequired,
   getClientByDocument: PropTypes.func.isRequired,
   turnControl: PropTypes.bool.isRequired,
   setTurnControl: PropTypes.func.isRequired,
   cloneQuotasFromLastWeek: PropTypes.func.isRequired,
};

export default ClientQuotasTabComponent;
